import { toast } from "react-toastify";
import { api } from "../../../utils/api";

import { getRegistrationType } from "../../GlobalRoles/getRegistrationTypes";

export const onSubmitDeleteRegistrationType = async (
  resetType,
  setLoading,
  setVisible,
  data,
) => {
  const notification = toast.loading("Deletando..");
  try {
    var id = data;
    setLoading(true);
    await api.delete(`type-cli/${id}`);

    // Executar GetRegistrationType após a atualização bem-sucedida
    await getRegistrationType(setLoading);

    resetType();
    toast.update(notification, {
      render: "Tipo de Cadastro Excluído com Sucesso!",
      type: "success",
      theme: "colored",
      autoClose: 5000,
      isLoading: false,
    });
  } catch (error) {
    const errorMessage = error.response
      ? error.response.data.error
      : "Erro desconhecido ao excluir tipo de cadastro.";
    toast.update(notification, {
      render: `Não Possível Excluir Tipo de Cadastro! Erro: ${errorMessage}`,
      type: "error",
      theme: "colored",
      autoClose: 5000,
      isLoading: false,
    });
  } finally {
    setLoading(false);
    setVisible(false);
  }
};
